<template>
  <div
    class="option-button m-1 mb-3 p-4 text-center"
    :class="{ active: selected, disabled: disabled }"
    @click="$emit('click')"
  >
    <b-tooltip
      :label="disabled ? 'Cette option n\'est pas compatible avec votre configuration.' : ''"
      multilined
      position="is-top"
    >
      <div class="flex flex-col">
        <p class="has-text-primary">
          {{ title }}
        </p>
        <div class="svg-content flex justify-center content-between">
          <slot />
        </div>
        <div
          v-if="tooltip"
          class="flex justify-center mt-2"
        >
          <b-tooltip
            :label="tooltip"
            multilined
            position="is-bottom"
          >
            <font-awesome-icon icon="info-circle" />
          </b-tooltip>
        </div>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'OptionButton',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.option-button {
  background-color: #eaeaea;
  border-radius: 5px;
  cursor: pointer;
}

.disabled {
  background-color: #cacaca;
  cursor: not-allowed;
}

.active {
  background-color: rgba(0, 255, 13, 0.171);
  border: 2px solid green;
}
</style>
